import React, { FC, ReactNode } from 'react';

type Props = {
  title: string;
  agreed: boolean;
  open: boolean;
  // eslint-disable-next-line no-unused-vars
  onAgreedChange: (agreed: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
};

// One term: open it to read, and tick the box on the same line as its title to agree.
const Term: FC<Props> = ({
  title, agreed, open, onAgreedChange, onOpenChange, children,
}) => (
  <details
    className={`term${agreed ? ' agreed' : ''}`}
    open={open}
    onToggle={(e) => onOpenChange((e.currentTarget as HTMLDetailsElement).open)}
  >
    <summary>
      <input
        type="checkbox"
        className="t-ck"
        checked={agreed}
        aria-label={`I agree to ${title}`}
        // Ticking must not also open or close the term.
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => onAgreedChange(e.target.checked)}
      />
      <span className="t-title">{title}</span>
      <span className="chev" aria-hidden>▼</span>
    </summary>
    <div className="body">{children}</div>
  </details>
);

export default Term;
